(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["try-our-trampolines"] && !Shopify.designMode) return;
  try {
    
function scrollToProduct() {
  const productElement = document.querySelector('div.product-container');
  const navbarHeight = document.querySelector('header.navbar-container').offsetHeight;
  const y = productElement.offsetTop - navbarHeight;
  window.scroll({
    top: y,
    behavior: 'smooth'
  });
}

const buttonElement = document.querySelector('section.try-our-trampolines .button.primary');
buttonElement.onclick = e => {
  if (window.location.href.indexOf('/products/bungee-rebounders-mini-trampoline') > -1) {
    e.preventDefault();
    scrollToProduct();
  }
}

  } catch(e) { console.error(e); }
})();
})();
